export const agent = {
  applications: 'تطبيقات',
  leads: 'عملاء متوقعون',
  map: 'خريطة',
  menu: 'قائمة',
  searchPlaceholder: 'بحث',
  OPENED: 'مفتوح',
  DONE: 'مكتمل',
  ALL: 'الكل',
  APPLICATION: 'طلب',
  LEAD: 'عميل متوقع',
  Status: 'الحالة',
  Emirate: 'إمارة',
  CreatedDate: 'تاريخ الإنشاء',
  'Created date from': 'تاريخ الإنشاء من',
  'Created date to': 'تاريخ الإنشاء إلى',
  Assignee: 'محال',
  Filter: 'تصفية',
  'Sort by': 'فرز حسب',
  Terminate: 'إنهاء',
  'Flag as Contacted': 'مصنف كـ تم الاتصال',
  'Create Application': 'إنشاء طلب',
  Confirm: 'تأكيد',
  'Are you ready to create Merchant Application?': 'هل أنت جاهز لإنشاء طلب تاجر؟',
  'Merchant onboarding application will be created for this merchant. Please confirm to proceed.': 'سيتم إنشاء طلب التسجيل لهذا التاجر. يرجى التأكيد للمتابعة.',
  'Are you sure?': 'هل أنت متأكد؟',
  'Please define the reason why you would like to terminate merchant onboarding process.': 'يرجى تحديد سبب رغبتك في إنهاء تسجيل التاجر.',
  'Reason for termination': 'سبب الإنهاء',
  'Termination reason': 'سبب الإنهاء',
  'Termination date': 'تاريخ الإنهاء',
  Save: 'حفظ',
  'Convert to Application': 'تحويل إلى طلب',
  'Application ID': 'رقم الطلب',
  'CR Unified Number': 'رقم السجل الموحد',
  'New Lead': 'عميل متوقع جديد',
  'Create Lead': 'إنشاء عميل متوقع',
  'Lead source': 'مصدر العميل المتوقع',
  'Customer type': 'نوع العميل',
  'Company basic details': 'معلومات الشركة الأساسية',
  'Company Name': 'اسم الشركة',
  'Company type': 'نوع الشركة',
  'Company contact person': 'جهة الاتصال بالشركة',
  'Business nature': 'طبيعة العمل',
  'Please specify company business nature': 'يرجى تحديد طبيعة عمل الشركة',
  'Please specify company contact person': 'يرجى تحديد جهة الاتصال بالشركة',
  'Please upload a photo of outside the outlet': 'يرجى تحديد صورة لخارج المحل',
  'Please upload a photo of inside the outlet': 'يرجى تحميل صورة داخل المحل',
  'Select the products that merchant is interested in': 'اختر المنتجات التي يهتم بها التاجر',
  'Please select company type': 'يرجى تحديد نوع الشركة',
  'Please select industry': 'يرجى تحديد المجال',
  'Please select business line': 'يرجى تحديد خط العمل',
  'First name': 'الاسم الأول',
  'Last name': 'الاسم الأخير',
  Address: 'العنوان',
  'Address line': 'سطر العنوان',
  Products: 'المنتجات',
  'N-Genius POS': 'نقاط البيع',
  'E-commerce': 'التجارة الإلكترونية',
  'Soft POS': 'Soft POS نقاط البيع ',
  'Referral code': 'رمز الإحالة',
  'Partner referral code': 'رمز إحالة الشريك',
  'Terminate Lead': 'إنهاء العميل المتوقع',
  'Terminate Application': 'إنهاء الطلب',
  'Go to Application': 'الانتقال إلى الطلب',
  Activate: 'تنشيط',
  'Business line': 'خط العمل',
  Company: 'الشركة',
  Contact: 'جهة الاتصال',
  Created: 'تم الإنشاء',
  Request: 'طلب',
  'Risk level': 'مستوى المخاطر',
  Updated: 'محدث',
  Region: 'المنطقة',
  'Created date': 'تاريخ الإنشاء',
  'Submitted date': 'تاريخ الإرسال',
  from: 'من',
  to: 'إلى',
  'Manual review': 'مراجعة يدوية',
  Submitted: 'مقدم',
  'Unassigned': 'غير محال',
  'Current User': 'المستخدم الحالي',
  '<strong>{{type}}</strong> created {{date}}': '<strong>{{type}}</strong> تم إنشاؤه {{date}}',
  '"{{companyName}}" company will be deleted.': 'سيتم حذف الشركة "{{companyName}}".',
  'Bank Report Download': 'تحميل تقرير البنك',
  'TMS Registration Report Download': 'تحميل تقرير تسجيل TMS',
  'Download Failed': 'فشل التحميل',
  'An error occurred while downloading the report. Please try again.': 'حدث خطأ أثناء تحميل التقرير. يرجى المحاولة مرة أخرى.',
  'Way4 Files': 'ملفات Way4',
  'Way4 onboarding files': 'ملفات تسجيل Way4',
  'Way4 Files tooltip': '{{count}} ملف لرفعه إلى Way4',
  'Way4 download error': 'فشل تنزيل الملف',
  "Something went wrong. Please try again.": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
  'Failed to terminate lead. Please try again.': 'فشل إنهاء العميل المتوقع. يرجى المحاولة مرة أخرى.',
};

export const leadStatus = {
  NEW: 'جديد',
  CONTACTED: 'تم الاتصال',
  TERMINATED: 'منتهي',
  CONVERTED: 'تم التحويل ',
};

export const applicationStatus = {
  duplicate: 'مكرر',
  draft: 'مسودة',
  terminated: 'منتهي',
  fillingData: 'تعبئة البيانات',
  rejected: 'مرفوض',
  screeningFailed: 'فشل الفحص',
  onReview: 'قيد المراجعة',
  approval: 'موافقة',
  onboarding: 'التسجيل',
  posPreparation: 'إعداد نقاط البيع',
  posInstallation: 'تركيب نقاط البيع',
  completed: 'مكتمل',
  hardRejected: 'رفض نهائي',
  screening: 'فحص',
  contract: 'عقد',
  payment: 'دفع',
  submissionFailure: 'فشل الإرسال',
  services: 'خدمات',
  automatedOnboarding: 'التسجيل الآلي',
  failedOnboarding: 'فشل التسجيل',
  manualOnboarding: ' التسجيل اليدوي',
};
